import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Table from '../ogComponent/table';

export default function ProcessSalary() {
  const [searchParams] = useSearchParams();
  const paymonth = searchParams.get('paymonth') || '';
  const [salaryData, setSalaryData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const navigate = useNavigate();
  const token = localStorage.getItem("accessToken");

  const tableHeaders = [
    { label: 'Employee ID', name: 'employee_id', active: true },
    { label: 'Employee Name', name: 'employee_name', active: true },
    { label: 'Calculated Salary', name: 'calculated_salary', active: true },
    { label: 'Paid Salary', name: 'paid_salary', active: true },
  ];

  useEffect(() => {
    // if (paymonth) {
      fetchSalaryData();
    // }
  }, []);

  const fetchSalaryData = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_API}/api/attendance/list-salary-all-employees/?pay_month=${paymonth}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setSalaryData(response.data.data.map(item => ({
        ...item,
        paid_salary: item.paid_salary || '',
      })));
    } catch (error) {
      toast.error('Error fetching salary data');
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleSalaryChange = (employeeId, value) => {
    setSalaryData(prev =>
      prev.map(item =>
        item.employee_id === employeeId ? { ...item, paid_salary: value } : item
      )
    );
  };

  const handleGenerateSalary = async () => {
    try {
      setLoading(true);
      const payload = salaryData
        .filter(item => item.paid_salary !== '' && item.paid_salary !== null)
        .map(item => ({
          employee_id: item.employee_id,
          paid_salary: parseFloat(item.paid_salary),
        }));

      if (payload.length === 0) {
        toast.error('No valid salary data to submit');
        return;
      }

      await axios.patch(
        `${process.env.REACT_APP_API}/api/attendance/salary-slips/update-paid-salary/?pay_month=${paymonth}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      toast.success('Salaries updated successfully');
      navigate('/user/salaryslip');
    } catch (error) {
      toast.error('Error updating salaries');
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleRowClick = (item) => {
    // Optional: Add row click functionality if needed
  };

  const modifiedSalaryData = salaryData.map(item => ({
    ...item,
    paid_salary: (
      <input
        type="number"
        className="form-control"
        value={item.paid_salary}
        onChange={(e) => handleSalaryChange(item.employee_id, e.target.value)}
        onClick={(e) => e.stopPropagation()}
        disabled={loading}
      />
    ),
  }));

  return (
    <div className="px-4 py-3 w-100">
      <h4>Process Salaries for {paymonth}</h4>
      <Table
        header={tableHeaders}
        product={modifiedSalaryData}
        onRowClick={handleRowClick}
        loading={loading}
        currentPage={currentPage}
        onPageChange={setCurrentPage}
      />
      <div className="w-100 d-flex justify-content-end mt-3">
        <button
          className="btn btn-primary"   
          onClick={handleGenerateSalary}
          disabled={loading}
        >
          {loading ? 'Generating...' : 'Generate Salary'}
        </button>
      </div>
      <ToastContainer position="bottom-right" autoClose={3000} />
    </div>
  );
}